import React, { SyntheticEvent, useState } from 'react';
import { Modal, Button } from 'antd';

interface SignModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (show: boolean) => void;
}

const SignModal: React.FC<SignModalProps> = ({ isModalOpen, setIsModalOpen }) => {
    const [isImageLoaded, setIsImageLoaded] = useState<boolean>(false);

    const handleImageLoad = (event: SyntheticEvent<HTMLImageElement, Event>) => {
        setIsImageLoaded(true);
    };

    return (
        <Modal centered closable={false} title="" open={isModalOpen} width={350} wrapClassName="sign-modal-wrap" footer={null}>
            <div style={{ visibility: isImageLoaded ? 'visible' : 'hidden' }}>
                <div className="sign-method-content">
                    <img
                        width="100%"
                        height="100%"
                        src="https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202102/01/a6207_20210201165801.gif"
                        alt="Sign Method"
                        onLoad={handleImageLoad}
                    />
                </div>
                <Button shape="round" type="primary" className="sign-confirm-btn" onClick={() => setIsModalOpen(false)}>
                    知道了
                </Button>
            </div>
        </Modal>
    );
};

export default SignModal;
